const STATUS_MAP = {
  /* Attendance */
  PRESENT: { tone: "success", label: "Present" },
  ABSENT: { tone: "error", label: "Absent" },
  IN: { tone: "success", label: "In" },
  OUT: { tone: "success", label: "Out" },
  IDLE: { tone: "neutral", label: "Idle" },
  WFH: { tone: "info", label: "WFH" },
  ON_SITE: { tone: "success", label: "On Site" },
  YES: { tone: "info", label: "Yes" },
  NO: { tone: "success", label: "No" },

  /* Work / journey */
  START: { tone: "success", label: "Work Started" },
  END: { tone: "error", label: "Work Ended" },
  JOURNEY_START: { tone: "warning", label: "Journey Started" },
  JOURNEY_END: { tone: "warning", label: "Journey Ended" },

  /* Ticket lifecycle */
  OPEN: { tone: "warning", label: "Open" },
  WORK_IN_PROGRESS: { tone: "warning", label: "In Progress" },
  IN_PROGRESS: { tone: "warning", label: "In Progress" },
  ASSIGNED: { tone: "info", label: "Assigned" },
  ASSIGNED_TICKET: { tone: "info", label: "Assigned" },
  CLAIMED: { tone: "info", label: "Claimed" },
  SELF_ASSIGNED: { tone: "info", label: "Self Assigned" },
  PARTIALLY_CLOSED: { tone: "warning", label: "Partially Closed" },
  CLOSED: { tone: "neutral", label: "Closed" },
  RESOLVED: { tone: "success", label: "Resolved" },
  COMPLETED: { tone: "success", label: "Completed" },
  STOP: { tone: "error", label: "Stopped" },
  CANCELLED: { tone: "error", label: "Cancelled" },
  CANCELED: { tone: "error", label: "Cancelled" },
  DEACTIVATED: { tone: "error", label: "Deactivated" },
  INVALID: { tone: "error", label: "Invalid" },
  REOPENED: { tone: "info", label: "Reopened" },

  /* Approval / workflow */
  PENDING: { tone: "warning", label: "Pending" },
  APPROVED: { tone: "success", label: "Approved" },
  REJECTED: { tone: "error", label: "Rejected" },
  HOLD: { tone: "warning", label: "On Hold" },

  /* Purchase order / general */
  ACTIVE: { tone: "success", label: "Active" },
  INACTIVE: { tone: "neutral", label: "Inactive" },
  SENT: { tone: "info", label: "Sent" },
  PAYMENT_DONE: { tone: "success", label: "Payment Done" },
  DRAFT: { tone: "neutral", label: "Draft" },
  PAID: { tone: "success", label: "Paid" },
  UNPAID: { tone: "error", label: "Unpaid" },
  OVERDUE: { tone: "critical", label: "Overdue" },

  /* Quotation */
  ACCEPTED: { tone: "success", label: "Accepted" },
  DECLINED: { tone: "error", label: "Declined" },
  EXPIRED: { tone: "neutral", label: "Expired" },
  GENERATED: { tone: "info", label: "Generated" },

  /* Product fleet */
  AVAILABLE: { tone: "success", label: "Available" },
  TAGGED: { tone: "info", label: "Tagged" },
  WHATSAPP_REGISTER: { tone: "warning", label: "WhatsApp Registered" },
  WHATSAPP_REGISTERED: { tone: "warning", label: "WhatsApp Registered" },
  UNTAGGED: { tone: "success", label: "Untagged" },
  TRANSFERRED: { tone: "warning", label: "Transferred" },
  DAMAGED: { tone: "error", label: "Damaged" },
  TRANSFERRED: { tone: "warning", label: "Transferred" },
  TRANSFERED: { tone: "warning", label: "Transferred" },
  REQUESTED: { tone: "warning", label: "Requested" },

  /* Invoice / template */
  INVOICE_GENERATED: { tone: "info", label: "Invoice Generated" },
  INVOICE_PAID: { tone: "success", label: "Invoice Paid" },

  /* Swipe / work log */
  WORK_START: { tone: "warning", label: "Work Start" },
  WORK_END: { tone: "error", label: "Work End" },

  /* Priority */
  HIGH: { tone: "critical", label: "High" },
  CRITICAL: { tone: "critical", label: "Critical" },
  MEDIUM: { tone: "warning", label: "Medium" },
  LOW: { tone: "neutral", label: "Low" },
};

const SUCCESS_KEYS = [
  "SUCCESS",
  "COMPLETE",
  "DONE",
  "PAID",
  "APPROVE",
  "ACTIVE",
  "PRESENT",
  "RESOLV",
];

const ERROR_KEYS = [
  "FAIL",
  "ERROR",
  "REJECT",
  "ABSENT",
  "INACTIVE",
  "STOP",
  "CANCEL",
  "INVALID",
  "DEACTIV",
  "UNPAID",
  "OVERDUE",
];

const WARNING_KEYS = [
  "PEND",
  "OPEN",
  "PROGRESS",
  "HOLD",
  "WAIT",
  "PARTIAL",
  "JOURNEY",
  "MEDIUM",
];

const INFO_KEYS = ["ASSIGN", "CLAIM", "SENT", "INFO", "WFH", "YES"];

const CRITICAL_KEYS = ["CRITICAL", "URGENT", "HIGH"];

export function formatStatusLabel(value) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value)
    .replaceAll("_", " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function normalizeStatusKey(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "boolean") return value ? "YES" : "NO";
  return String(value).trim().toUpperCase().replace(/\s+/g, "_");
}

function inferTone(key) {
  if (CRITICAL_KEYS.some((k) => key.includes(k))) return "critical";
  if (ERROR_KEYS.some((k) => key.includes(k))) return "error";
  if (SUCCESS_KEYS.some((k) => key.includes(k))) return "success";
  if (WARNING_KEYS.some((k) => key.includes(k))) return "warning";
  if (INFO_KEYS.some((k) => key.includes(k))) return "info";
  return "neutral";
}

const EXCLUDED_STATUS_COLUMNS =
  /^(action|actions|sl_no|serial|index|worklog|work_log)$/i;

const STATUS_COLUMN_RE =
  /(status|attendance|priority|wfh|approval|pending|invoice|template|paid|unpaid|resolved|swipe)/i;

export function isStatusColumn(columnKey) {
  if (!columnKey || typeof columnKey !== "string") return false;
  if (EXCLUDED_STATUS_COLUMNS.test(columnKey)) return false;
  if (columnKey === "attendance" || columnKey === "is_wfh") return true;
  return STATUS_COLUMN_RE.test(columnKey);
}

export function getItemStatusValue(item, columnKey) {
  if (!item || !columnKey) return "";

  if (columnKey === "attendance") {
    const s = item.attendance_status;
    if (s === "IN" || s === "OUT") return "PRESENT";
    if (s) return "ABSENT";
    return item[columnKey] ?? "";
  }

  if (columnKey === "is_wfh") {
    return item.is_wfh ? "YES" : "NO";
  }

  const raw = item[columnKey];
  if (raw === null || raw === undefined) return "";
  return raw;
}

export function resolveStatusChip(value, labelOverride) {
  const key = normalizeStatusKey(value);

  if (!key || key === "-") {
    return { tone: "neutral", label: labelOverride || "-" };
  }

  const mapped = STATUS_MAP[key];
  if (mapped) {
    return {
      tone: mapped.tone,
      label: labelOverride || mapped.label || formatStatusLabel(value),
    };
  }

  return {
    tone: inferTone(key),
    label: labelOverride || formatStatusLabel(value),
  };
}
